import type { date } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import type { FC } from 'react';
import { CurrentUserPasswordForm } from './CurrentUserPasswordForm';
import { UserForm } from './UserForm';

export interface UserFormValues {
  username: string;
  timezone: date.Timezone;
  oldPassword: string;
  newPassword: string;
  retypePassword: string;
}

export type Props = {
  onSaveSuccess?: () => void;
};

export const UserProfile: FC<Props> = (props) => {
  const ctxProps = useGlobalStateContextSelectors({
    isLocalUser: prop('user', 'isLocal'),
  });

  return (
    <>
      <UserForm onSaveSuccess={props.onSaveSuccess} />
      {ctxProps.isLocalUser && <CurrentUserPasswordForm className='mt-12' />}
    </>
  );
};
